// @docs https://[domain]/api/v1/docs#/PYR%2FEmployee%20Reward%20Discipline
export default {
  List: "/pyr/employee-reward-disciplines",
  Create: "/pyr/employee-reward-disciplines",
  Detail: "/pyr/employee-reward-disciplines/{id}",
  Update: "/pyr/employee-reward-disciplines/{id}",
  Delete: "/pyr/employee-reward-disciplines/{id}",
};
